// Handoff helpers for launching the new (v2) ERP with the current session so
// users never have to log in again when they try the beta.

export const BETA_URL =
  process.env.REACT_APP_BETA_URL || "https://beta-v2.ekalsutra.com";

/** base64url-encode a JS object (unicode-safe) for the SSO hash param. */
function encodeSSO(obj) {
  const json = JSON.stringify(obj);
  const bytes = new TextEncoder().encode(json);
  let binary = "";
  bytes.forEach((b) => {
    binary += String.fromCharCode(b);
  });
  return btoa(binary)
    .replace(/\+/g, "-")
    .replace(/\//g, "_")
    .replace(/=+$/, "");
}

/**
 * Build the SSO payload from redux state + localStorage, matching the shapes
 * the v2 auth/school stores expect (`setSession` / `setSchoolAccess`).
 * Returns `null` if the essential auth token is missing.
 */
export function buildSSOUrl({
  userDocId,
  username,
  roles,
  selectedSchool,
  primaryRole,
  menuOptionsToShow,
  sessionList,
  activeSession,
}) {
  const authAccessToken = localStorage.getItem("authAccessToken");
  const authRefreshToken = localStorage.getItem("authRefreshToken");
  if (!authAccessToken) return null;

  const auth = {
    userDocId,
    username,
    roles: roles || [],
    token: authAccessToken,
    refreshToken: authRefreshToken,
  };

  let school;
  const schoolToken = localStorage.getItem("schoolToken");
  if (schoolToken && selectedSchool?._id) {
    const addr = selectedSchool.schoolAddress || {};
    const location = [addr.dist, addr.state, addr.pinCode]
      .filter(Boolean)
      .join(", ");
    school = {
      school: {
        _id: selectedSchool._id,
        name: selectedSchool.schoolName,
        schoolLogo: selectedSchool.schoolLogo,
        location: location || undefined,
        instituteType: selectedSchool.instituteType,
        activeSession: activeSession || selectedSchool.activeSession,
        sessionList: (sessionList || [])
          .map((s) => s?.sessionName || s)
          .filter(Boolean),
        primaryRole: primaryRole || selectedSchool.primaryRole,
      },
      schoolToken,
      schoolRefreshToken: localStorage.getItem("schoolRefreshToken"),
      menuOptionsToShow: menuOptionsToShow || {},
    };
  }

  const encoded = encodeSSO({ auth, school });
  return `${BETA_URL.replace(/\/$/, "")}/sso#d=${encoded}`;
}
